import Home from "./public/Home";
import About from "./public/About";
import EventPage from "./public/Event";
import Registration from "./public/Registration";
import Sponsorship from "./public/Sponsorship";
import Speakers from "./public/Speakers";
import Venue from "./public/Venue";
import { NewsList } from "./public/News";
import Contact from "./public/Contact";
import { PrivacyPolicy, RefundPolicy, ServiceDelivery, Terms } from "./public/LegalPage";

export const PAGE_COMPONENTS = {
  home: Home, about: About, event: EventPage, registration: Registration, sponsorship: Sponsorship,
  speakers: Speakers, venue: Venue, news: NewsList, contact: Contact,
  "privacy-policy": PrivacyPolicy, "refund-policy": RefundPolicy, terms: Terms, "service-delivery": ServiceDelivery,
};

export const PAGE_PATHS = {
  home: "/", about: "/about", event: "/event", registration: "/registration", sponsorship: "/sponsorship",
  speakers: "/speakers", venue: "/venue", news: "/news", contact: "/contact",
  "privacy-policy": "/privacy-policy", "refund-policy": "/refund-policy", terms: "/terms", "service-delivery": "/service-delivery",
};
